import type {
  LoginUIConfig,
  LoginUIInitOptions,
} from '@xbase/login-ui'
import tenTBStorage from 'assets/images/mobile-app/10t-storage.svg'
import cloudDownload from 'assets/images/mobile-app/cloud-download.svg'
import speedSave from 'assets/images/mobile-app/speed-save.svg'
import highQuality from 'assets/images/tv-app/icon_4k.svg'
import changeSubtitle from 'assets/images/tv-app/icon_cc.svg'
import changeVoice from 'assets/images/tv-app/icon_voice.svg'
import {
  getDomain,
  getGlobal,
} from '~/utils'
import { DEFAULT_LOCALE } from '~/types/constants'
import { getLocale } from '~~/plugins/i18n'

// 当前运行环境是否为develop
const isDev = process.dev

enum LogLevel {
  OFF = 'off',
  ERROR = 'error',
  WARN = 'warn',
  DEBUG = 'debug',
  INFO = 'info',
}

export const webClientId = isDev ? 'Ybm05APId_4L8Ftd' : 'YUMx5nI8ZU8Ap8pm'
export const googleClientID = '1016306462377-gacp3qbg1hp8ei82510fnmfgv1ug0oio.apps.googleusercontent.com' as const

export const loginUIConfig: LoginUIConfig = {
  loginConfig: {
    consumerContext: {
      project_id: '2we4lk44iqprwaf1m0s',
      client_id: webClientId,
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    locale: import.meta.client ? getLocale() as any : DEFAULT_LOCALE,
  },
  logLevel: isDev ? LogLevel.DEBUG : LogLevel.OFF,
}

export const loginInitParams: LoginUIInitOptions = {
  loginInitOptions: {
    isLoginFlow: true,
    apiOrigins: [isDev ? `https://dev-user.${getDomain()}` : `https://user.${getDomain()}`],
    clientId: webClientId,
    appVersion: '1.0.0',
    enableLocalDeviceSignInWeb: true,
    enableSynchornizeAppLoginState: true,
    useAppClientId: false,
    captchaRedirectPage: `${getGlobal().location?.origin}/loading`,
    appId: '',
    noHostCategoryAppName: '',
    enableCookieSessionInfo: false,
    enableQrCodeLoginShortUri: true,
    preFpRtName: 'pp',
  },
  localRunningConfig: {
    userAgreementURI: 'https://mypikpak.com/policy/user-agreement',
    privacyAgreementURI: 'https://mypikpak.com/policy/privacy-policy',
    modifyPasswordURI: '',
  },
}

export const features = [
  {
    caption: 'mobile-app-feature-1',
    imgSrc: cloudDownload,
  },
  {
    caption: 'mobile-app-feature-2',
    imgSrc: tenTBStorage,
  },
  {
    caption: 'mobile-app-feature-3',
    imgSrc: speedSave,
  },
]

export const tvFeatures = [
  {
    caption: 'tv-quality',
    imgSrc: highQuality,
  },
  {
    caption: 'tv-feature-2',
    imgSrc: changeSubtitle,
  },
  {
    caption: 'tv-feature-3',
    imgSrc: changeVoice,
  },
]

// PikPak插件id
export const getExtensionId = () => {
  const isEdge = /edg/i.test(window.navigator.userAgent)
  return isEdge ? 'jkmnnedinolbhjcibbfpdlkmmibkcbgf' : 'ohpgjiplhigpfcioaeakjfjnkbgjpgbl'
}
